import { TOUR_COMPLETED_STORAGE_KEY } from '@/components/TourMode/const';

type TourCompletionStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function getCompletedProjects(
  storage: TourCompletionStorage = localStorage,
): string[] {
  try {
    const raw = storage.getItem(TOUR_COMPLETED_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function markProjectCompleted(
  projectId: string,
  storage: TourCompletionStorage = localStorage,
): void {
  try {
    const list = getCompletedProjects(storage);
    if (!list.includes(projectId)) {
      list.push(projectId);
      storage.setItem(TOUR_COMPLETED_STORAGE_KEY, JSON.stringify(list));
    }
  } catch {
    // Completion persistence is best-effort. Storage can be unavailable or
    // quota-limited and must never block returning from the Aha fullscreen.
  }
}

export function isProjectCompleted(
  projectId: string,
  storage: TourCompletionStorage = localStorage,
): boolean {
  return getCompletedProjects(storage).includes(projectId);
}
